'use strict';

import * as Props from '../Props';

const angular = require('angular');

const DisplayFieldPropertise = {
    Basic: {
        'ControlType': 'DisplayField',
        'Label': {
            name: 'label',
            selectedValue: 'Label',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
            isSelected:false
        },
        'Field Name': Props.getFieldName('Calculated_Value'),        
        'Value': {
            name: 'value',
            selectedValue: '',
            type: 'textbox',
            onClickFunction: 'existingDataField',
            addOnButton: 'fa fa-function',
            onChangeFunction: 'updateDSField',
            readonly:false
        },
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
        'Type':{
            number:false,
            numberUnderRepeatingTable:false,
            hidden:true,
            calculation:""
        },
        'formula':{
            name: '',
            selectedValue:'',
            rules:'',
            type:'div',
            hidden:true,
            class:'formulaDiv',
            html:'',
            advanceQuery:'',
            edit:false,
            editText: "Edit",
            editedValue: "",
            uids:[]
        },
        'parentNode':{
            id:0,
            hidden:true,
            footer:false
        },
        'list':{
            hidden:true,
            listItem:[
                {
                    id:0,
                    drag:{
                        name:"drag"
                    },
                    field:{
                        name:"field",
                        value:'',
                        onClickFunction: 'existingDataField',
                        selectedType:''
                    },
                    operator:{
                        name:"operator",
                        options:[
                            {
                                key: 'Equal to',
                                value: 'Equal to'
                            },
                            {
                                key: 'Not equal to',
                                value: 'Not equal to'
                            },
                            {
                                key: 'Empty',
                                value: 'Empty'
                            },
                            {
                                key: 'Not empty',
                                value: 'Not empty'
                            },
                            {
                                key: 'Less than',
                                value: 'Less than'
                            },
                            {
                                key: 'Greater than',
                                value: 'Greater than'
                            }
                        ],
                        selected: 'Equal to'
                    },
                    target:{
                        name:"target",
                        value:0 ,
                        hidden:false,
                        disable:false      
                    },
                    conjuction:{
                        name:"conjuction",
                        hidden:true,
                        options:[
                            {
                                key:'AND',
                                value:'AND'
                            }
                        ],
                        selected: 'AND'
                    },
                    add:{
                        title:"add.condition"                        
                    },
                    remove:{
                        title:"remove.condition",
                        hidden:true
                    },
                    addField:{
                        name:"addField",
                        value:'',
                        disable:true
                    },
                    addSum:{
                        name:"addSum",
                        disable:true
                    },
                }
            ]
        }
    },
    Display: {
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    }
};

export default DisplayFieldPropertise;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Display_Field.ts